/** @format */

import React, { useState } from "react";
import HeaderWrapper from "../../../../components/common/HeaderWrapper";
import Table from "../../ApplicationsPage/AnalystApp/Table";

import { rows } from "../../../../utils/Data";
import { SearchIcon } from "../../../../components/common/IconComponents";
import { useNavigate } from "react-router-dom";

const Applications = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchChange = (event) => {
    const query = event.target.value;
    const sanitizedText = query.replace(/\s/g, "");
    setSearchTerm(sanitizedText);
  };
  const navigate = useNavigate();

  const filteredRows = rows.filter((row) =>
    row.Name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleProfileClick = (applicantId) => {
navigate(`/dashboard/profile/${applicantId}`);
  };

  return (
    <div>
      <HeaderWrapper>
        <div className="flex flex-wrap w-full  items-center gap-8  font-Inter">
          <h3 className="text-lg font-medium">Applications</h3>
          <div className="relative flex items-center">
            <SearchIcon
              className="w-3 h-5 absolute ml-3 pointer-events-none"
              icon={SearchIcon}
            />

            <input
              className="pr-3 pl-10 border-0 bg-gray-50 w-48 md:w-64 lg:w-96 rounded-3xl placeholder-p-2"
              type="text"
              id="name"
              autoComplete="off"
              placeholder="search"
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>
        </div>
      </HeaderWrapper>

      <Table
        arrays={filteredRows}
        showActions={true}
        onProfileClick={handleProfileClick}
      />
    </div>
  );
};

export default Applications;
